export const media = {
  sm: "(min-width: 576px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 992px)",
};

export const mediaQueries = {
  mobile: `@media ${media.sm}`,
  tablet: `@media ${media.md}`,
  desktop: `@media ${media.lg}`,
};

export const colors = {
  //primaryOne: "#ff2a61",
  //primaryOne: "#911f19",
  primaryOne: "#ad0c03",
  primary2: "#e5205e",
  white: "#ffffff",
  black: "#000000",
  grey: "#969393",
  grey2: "#f4f4f4",
  success: "#43a047",
};

export const lightTheme = {
  mode: "light",
  primaryOne: "#ad0c03",
  body: "#ffffff",
  text: "#000000",
  textPrimary: "#ad0c03",
  card: "#f8f9fa",
  inputBgOnPrimary: "#d5b0b0de",
  grey: "#969393",
};

export const darkTheme = {
  mode: "dark",
  primaryOne: "#8C1414",
  body: "#121212",
  text: "#ffffff",
  textPrimary: "#f8d909",
  card: "#5B5A5ACC",
  inputBgOnPrimary: "#2a14148c",
  grey: "#969393",
};
